const initialState = {
  fetching: false,
  fetched: false,
  saving: false,
  saved: false,
  data: {
    planning: {
      holidays: {
        JAN: [],
        FEV: [],
        MAR: [],
        AVR: [],
        MAI: [],
        JUN: [],
        JUL: [],
        AOU: [],
        SEP: [],
        OCT: [],
        NOV: [],
        DEC: []
      },
      annualHolidays: {
        JAN: [],
        FEV: [],
        MAR: [],
        AVR: [],
        MAI: [],
        JUN: [],
        JUL: [],
        AOU: [],
        SEP: [],
        OCT: [],
        NOV: [],
        DEC: []
      },
      workingDays: {
        JAN: [],
        FEV: [],
        MAR: [],
        AVR: [],
        MAI: [],
        JUN: [],
        JUL: [],
        AOU: [],
        SEP: [],
        OCT: [],
        NOV: [],
        DEC: []
      }
    }
  },
  error: null,
  selectedDays: { from: undefined, to: undefined },
  activatedOption: null,
  files: [],
  year: null,
  modifiers: {
    holidays: [],
    annualHolidays: [],
    workingDays: [],
    disabled: { daysOfWeek: [0, 6] }
  }
};

export const calendarSettingsReducer = (state = initialState, action) => {
  switch (action.type) {
    case "INIT_CALENDAR_SETTINGS": {
      return initialState;
    }
    case "SET_CALENDAR_SELECTED_DAYS": {
      return {
        ...state,
        selectedDays: action.selectedDays
      };
    }
    case "SET_CALENDAR_SELECTED_FILES": {
      return {
        ...state,
        files: action.files
      };
    }
    case "SET_CALENDAR_YAER": {
      return {
        ...state,
        year: action.year
      };
    }
    case "SET_CALENDAR_ACTIVATED_OPTION": {
      return {
        ...state,
        activatedOption: action.activatedOption
      };
    }
    case "SET_CALENDAR_MODIFIERS": {
      return {
        ...state,
        modifiers: action.modifiers
      };
    }
    case "SET_CALENDAR_PLANNING": {
      return {
        ...state,
        data: {
          ...state.data,
          planning: { ...action.planning }
        }
      };
    }
    case "SET_CALENDAR_ID": {
      return {
        ...state,
        data: {
          ...state.data,
          id: action.id
        }
      };
    }
    case "INIT_CALENDAR_SELECT": {
      return {
        ...state,
        files: [],
        selectedDays: { from: undefined, to: undefined },
        activatedOption: null
      };
    }

    case `SAVE_CALENDAR_SETTINGS_PENDING`: {
      return { ...state, saved: false, saving: true };
    }
    case `SAVE_CALENDAR_SETTINGS_FULFILLED`: {
      return {
        ...state,
        saving: false,
        saved: true
      };
    }
    case `SAVE_CALENDAR_SETTINGS_REJECTED`: {
      let error = action.payload;
      switch (error.response.status) {
        case 500:
          error = {
            title: error.response.data.title,
            code: 500
          };
          break;
        default:
          error = {
            title: error.response.data.errors
              ? error.response.data.errors[0].message
              : "An error has occured",
            code: error.response.data.errors
              ? error.response.data.errors[0].code
              : 500
          };
      }
      return {
        ...state,
        saved: false,
        saving: false,
        error
      };
    }

    case "FETCH_CALENDAR_SETTINGS_PENDING": {
      return { ...state, fetching: true, fetched: false };
    }
    case "FETCH_CALENDAR_SETTINGS_FULFILLED": {
      let result = action.payload.data.data;

      if (result.length === 0) {
        return {
          ...state,
          fetching: false,
          fetched: true,
          error: null
        };
      }

      let modifiersDates = {};
      let planningDates = {};

      for (let type in result.modifiers) {
        modifiersDates[type] = result.modifiers[type].map(item => {
          return new Date(item);
        });
      }

      for (let type in result.planning) {
        planningDates[type] = {};
        for (let month in result.planning[type]) {
          planningDates[type][month] = result.planning[type][month].map(
            item => {
              return { ...item, date: new Date(item.date) };
            }
          );
        }
      }

      // result.planning = planningDates;

      return {
        ...state,
        fetching: false,
        fetched: true,
        error: null,
        data: { ...result, planning: planningDates },
        modifiers: modifiersDates
      };
    }
    case "FETCH_CALENDAR_SETTINGS_REJECTED": {
      let error = action.payload;
      switch (error.response.status) {
        case 404:
          error = {
            title: error.response.data.title,
            code: 404
          };
          break;
        default:
          error = {
            title: error.response.data.errors
              ? error.response.data.errors[0].message
              : "An error has occured",
            code: error.response.data.errors
              ? error.response.data.errors[0].code
              : 500
          };
      }
      return {
        ...state,
        fetching: false,
        data: [],
        error
      };
    }

    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/reducers/calendar-settings.js